"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanObject = void 0;
var utils_1 = require("./utils");
var defaultOptions = {
    deep: false,
    skipNull: false,
    emptyStrings: true,
    emptyInvalidNumbers: true,
    emptyArrays: false,
    emptyObjects: false,
};
function cleanObject(originalObj, options) {
    var _a, _b, _c, _d, _e, _f;
    if (options === void 0) { options = defaultOptions; }
    var deep = (_a = options.deep) !== null && _a !== void 0 ? _a : defaultOptions.deep;
    var skipNull = (_b = options.skipNull) !== null && _b !== void 0 ? _b : defaultOptions.skipNull;
    var emptyStrings = (_c = options.emptyStrings) !== null && _c !== void 0 ? _c : defaultOptions.emptyStrings;
    var emptyInvalidNumbers = (_d = options.emptyInvalidNumbers) !== null && _d !== void 0 ? _d : defaultOptions.emptyInvalidNumbers;
    var emptyArrays = (_e = options.emptyArrays) !== null && _e !== void 0 ? _e : defaultOptions.emptyArrays;
    var emptyObjects = (_f = options.emptyObjects) !== null && _f !== void 0 ? _f : defaultOptions.emptyObjects;
    var obj = (0, utils_1.recursiveClone)(originalObj);
    for (var key in obj) {
        var value = obj[key];
        if (skipNull) {
            if (value === undefined) {
                delete obj[key];
                continue;
            }
        }
        else {
            if (value == undefined) {
                delete obj[key];
                continue;
            }
        }
        if (emptyStrings && value === '') {
            delete obj[key];
            continue;
        }
        if (emptyInvalidNumbers &&
            typeof value === 'number' &&
            isFinite(value) === false) {
            delete obj[key];
            continue;
        }
        if (emptyArrays && Array.isArray(value) && value.length === 0) {
            delete obj[key];
            continue;
        }
        if ((0, utils_1.isPlainObject)(value)) {
            if (deep) {
                obj[key] = cleanObject(value, {
                    deep: deep,
                    skipNull: skipNull,
                    emptyStrings: emptyStrings,
                    emptyInvalidNumbers: emptyInvalidNumbers,
                    emptyArrays: emptyArrays,
                    emptyObjects: emptyObjects,
                });
            }
            if (emptyObjects && Object.keys(obj[key]).length === 0) {
                delete obj[key];
                continue;
            }
        }
    }
    return obj;
}
exports.cleanObject = cleanObject;
